module.exports = __webpack_public_path__ + "img/arrow-turn.ddee2956.svg";